// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Productie.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
export const ProductieTaken = [
    {
        _id: 'productie0',
        type: TaskType.productie,
        title: 'Productie boost',
        cost: 1500,
        description: 'Productie controle',
        inGameEffectDescription: 'deze ronde gaat de productie met 5% omhoog (kan boven 100% komen)',
        inGameEffect: [InGameEffect.plus2AvailabilityOnce],
        needsSparepart: false,
        needsMechanic: false,
    },
    {
        _id: 'productie1',
        type: TaskType.productie,
        title: 'Productie boost',
        cost: 2000,
        description: 'Competitor analyse',
        inGameEffectDescription: 'deze ronde gaat de productie met 5% omhoog (kan boven 100% komen)',
        inGameEffect: [InGameEffect.plus5AvailabilityOnce],
        needsSparepart: false,
        needsMechanic: false,
    },
    {
        _id: 'productie2',
        type: TaskType.productie,
        title: 'Productie boost',
        cost: 3000,
        description: 'Monitoring',
        inGameEffectDescription: 'deze ronde gaat de productie met 10% omhoog (kan boven 100% komen)',
        inGameEffect: [InGameEffect.plus5AvailabilityOnce],
        needsSparepart: false,
        needsMechanic: false,
    },
    {
        _id: 'productie3',
        type: TaskType.productie,
        title: 'Productie boost',
        cost: 5000,
        description: 'Verminder idletime',
        inGameEffectDescription: 'De productie gaat met 5% omhoog voor de rest van het spel (kan boven 100% komen)',
        inGameEffect: [InGameEffect.plus5AvailabilityAlways],
        needsSparepart: false,
        needsMechanic: false,
    },
    {
        _id: 'productie4',
        type: TaskType.productie,
        title: 'Productie boost',
        cost: 7000,
        description: 'Automatisering',
        inGameEffectDescription: 'De productie gaat met 10% omhoog voor de rest van het spel (kan boven 100% komen)',
        inGameEffect: [InGameEffect.plus5AvailabilityAlways],
        needsSparepart: false,
        needsMechanic: false,
    },
];
